import { Fragment } from 'react'
import { flexRender, Row, Table as TanstackTable } from '@tanstack/react-table'

import * as styled from './Table.styled'

interface TableProps<T> {
  onRowClick?: (row: Row<T>) => void
  table: TanstackTable<T>
  hideHeader?: boolean
  hasLastTrBorderBottom?: boolean
  hasBorderBottom?: boolean
}

export const Table = <T,>({
  onRowClick: handleRowClick,
  table,
  hideHeader = true,
  hasLastTrBorderBottom = true,
  hasBorderBottom = true,
}: TableProps<T>) => {
  return (
    <styled.Table
      hasLastTrBorderBottom={hasLastTrBorderBottom}
      hasBorderBottom={hasBorderBottom}
      isRowClickable={Boolean(handleRowClick)}
    >
      <thead>
        {!hideHeader &&
          table.getHeaderGroups().map((headerGroup, rowIndex) => (
            <styled.TableRowHeader
              data-testid={`header-row-${rowIndex}`}
              key={headerGroup.id}
            >
              {headerGroup.headers.map((header) => (
                <Fragment key={header.id}>
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext()
                  )}
                </Fragment>
              ))}
            </styled.TableRowHeader>
          ))}
      </thead>
      <tbody>
        {table.getRowModel().rows.map((row, rowIndex) => (
          <tr
            className="table-row"
            data-testid={`row-${rowIndex}`}
            key={row.id}
            onClick={() => handleRowClick?.(row)}
          >
            {row.getVisibleCells().map((cell) => (
              <Fragment key={cell.id}>
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </Fragment>
            ))}
          </tr>
        ))}
      </tbody>
    </styled.Table>
  )
}
